import React from "react";
import { Text, Container } from "basis";

import { FormattedPrice } from "../../../../components";

export const SessionInfo = ({ session }) => {
  if (!session?.sessionID || !session?.amount) {
    return null;
  }

  return (
    <>
      <Container>
        <Text textStyle="body1">
          <strong>Reference:</strong>
        </Text>
        <Text textStyle="body1">{session.sessionID}</Text>
      </Container>
      <Container>
        <Text textStyle="body1">
          <strong>Cart total:</strong>
        </Text>
        <FormattedPrice price={session.amount} textStyle="body1" />
      </Container>
    </>
  );
};
